export default "__VITE_ASSET__NHka9nYi__"